import moment from 'jalali-moment';
import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Calendar, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import AlertDangerSVG from '../../assets/images/icons/alert-danger.svg';
import CalendarSVG from '../../assets/images/icons/calendar.svg';
import CheckGreenSVG from '../../assets/images/icons/check-green.svg';
import EditSVG from '../../assets/images/icons/edit.svg';

/*
    - api
*/
import getAPI from '../../api/get';
/*
    - api
*/
import post from '../../api/post';

const EditForm = ({ props, alertProps, reloadDashboardProps }) => {

    const [cities, setCities] = React.useState([]);
    const [citiesAndStates, setCitiesAndStates] = React.useState([]);   
    const [confirmEmailState, setConfirmEmailState] = React.useState('1');
    const [confirmId, setConfirmId] = React.useState('');
    const [emailAlert, setEmailAlert] = React.useState('');
    const [passengerProfileBirthdate, setPassengerProfileBirthdate] = React.useState('');
    const [passengerProfileMarriagedate, setPassengerProfileMarriagedate] = React.useState('');
    const [states, setStates] = React.useState([]);
    const [timer, setTimer] = React.useState(60);
    const [timerStatus, setTimerStatus] = React.useState(true);
    const [verifyCode, setVerifyCode] = React.useState('');
    const today = moment().locale('fa').format('YYYY/MM/DD');

    const [userProfileParameters, setUserProfileParameters] = React.useState({
        firstName: { value: '', color: 'dark' },
        lastName: { value: '', color: 'dark' },
        mobile: { value: '', color: 'dark' },
        email: { value: '', color: 'dark' }
    });

    const [passengerProfileParameters, setPassengerProfileParameters] = React.useState({
        nationalCode: { value: '', color: 'dark' },
        state: { value: '', color: 'dark' },
        city: { value: '', color: 'dark' },
        address: { value: '', color: 'dark' }
    });

    const [sendEmailConfirmCodeParameters, setSendEmailConfirmCodeParameters] = React.useState({
        email: { value: '', color: 'dark' }
    });

    React.useEffect(() => {
        if (props.userProfile.status === 200) {
            setUserProfileParameters({
                firstName: {
                    value: props.userProfile.data.firstName ?? '',
                    color: 'dark'
                },
                lastName: {
                    value: props.userProfile.data.lastName ?? '',
                    color: 'dark'
                },
                mobile: {
                    value: props.userProfile.data.mobile ?? '',
                    color: 'dark'
                },
                email: {
                    value: props.userProfile.data.email ?? '',
                    color: 'dark'
                }
            });
        }

        if (props.passengerProfile.status === 200) {
            setPassengerProfileParameters({
                nationalCode: {
                    value: props.passengerProfile.data.nationalCode ?? '',
                    color: 'dark'
                },
                state: {
                    value: props.passengerProfile.data.state ?? '',
                    color: 'dark'
                },
                city: {
                    value: props.passengerProfile.data.city ?? '',
                    color: 'dark'
                },
                address: {
                    value: props.passengerProfile.data.address ?? '',
                    color: 'dark'
                }
            });

            setPassengerProfileBirthdate(
                props.passengerProfile.data.birthDate
                    ? moment(props.passengerProfile.data.birthDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
                    : ''
            );
            setPassengerProfileMarriagedate(
                props.passengerProfile.data.marriageDate
                    ? moment(props.passengerProfile.data.marriageDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')
                    : ''
            );
        }
    }, [props]);

    React.useEffect(() => {
        const statesHelper = citiesAndStates.map(obj => ({ id: obj.id, title: obj.title }));
        const citiesHelper = [];

        citiesAndStates.forEach(parentObj => {
            parentObj.cities?.forEach(cityObj => {
                citiesHelper.push({ ...cityObj, stateId: parentObj.id });
            });
        });

        setStates(statesHelper);
        setCities(citiesHelper);
    }, [citiesAndStates, passengerProfileParameters.state.value]);

    const userProfileHandler = (key, value) => {
        if (key === 'firstName') {
            const isValid = value !== '' && /^[آ-ی ]+$/.test(value);
            setUserProfileParameters(prev => ({
                ...prev,
                firstName: { value, color: isValid ? 'dark' : 'danger' }
            }));
        }
        if (key === 'lastName') {
            const isValid = value !== '' && /^[آ-ی ]+$/.test(value);
            setUserProfileParameters(prev => ({
                ...prev,
                lastName: { value, color: isValid ? 'dark' : 'danger' }
            }));
        }
        if (key === 'mobile') {
            const isValid = value.length === 11 && /^[\u06F0-\u06F90-9]+$/.test(value);
            setUserProfileParameters(prev => ({
                ...prev,
                mobile: { value, color: isValid ? 'dark' : 'danger' }
            }));
        }
        if (key === 'email') {
            setUserProfileParameters(prev => ({
                ...prev,
                email: { value, color: 'dark' }
            }));
        }
    };

    const userProfile = async () => {
        let isValid = true;

        if (!userProfileParameters.firstName.value || !/^[آ-ی ]+$/.test(userProfileParameters.firstName.value)) {
            isValid = false;
            setUserProfileParameters(prev => ({ ...prev, firstName: { ...prev.firstName, color: 'danger' } }));
        }
        if (!userProfileParameters.lastName.value || !/^[آ-ی ]+$/.test(userProfileParameters.lastName.value)) {
            isValid = false;
            setUserProfileParameters(prev => ({ ...prev, lastName: { ...prev.lastName, color: 'danger' } }));
        }
        if (userProfileParameters.mobile.value.length !== 11 || !/^[\u06F0-\u06F90-9]+$/.test(userProfileParameters.mobile.value)) {
            isValid = false;
            setUserProfileParameters(prev => ({ ...prev, mobile: { ...prev.mobile, color: 'danger' } }));
        }

        if (isValid) {
            const body = {
                firstName: userProfileParameters.firstName.value,
                lastName: userProfileParameters.lastName.value,
                mobile: userProfileParameters.mobile.value,
                email: userProfileParameters.email.value
            };

            const parameters = {
                ctrl: 'UserProfile',
                method: 'EditUserProfile',
                query: '',
                body
            };

            const result = await post(parameters);
            if (result.status === 200) {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadDashboardProps(`${Math.floor(Math.random() * 100)},editForm`);
            } else {
                alertProps(['danger', result.data.Message]);
            }
        }
    };

    const passengerProfileHandler = (key, value) => {
        if (key === 'nationalCode') {
            const isValid = value.length === 10 && /^[\u06F0-\u06F90-9]+$/.test(value);
            setPassengerProfileParameters(prev => ({
                ...prev,
                nationalCode: { value, color: isValid ? 'dark' : 'danger' }
            }));
        }
        if (key === 'state') {
            setPassengerProfileParameters(prev => ({ ...prev, state: { value, color: 'dark' } }));
        }
        if (key === 'city') {
            setPassengerProfileParameters(prev => ({ ...prev, city: { value, color: 'dark' } }));
        }
        if (key === 'address') {
            setPassengerProfileParameters(prev => ({ ...prev, address: { value, color: 'dark' } }));
        }
    };

    const passengerProfile = async () => {
        let isValid = true;

        if (passengerProfileParameters.nationalCode.value.length !== 10 || !/^[\u06F0-\u06F90-9]+$/.test(passengerProfileParameters.nationalCode.value)) {
            isValid = false;
            setPassengerProfileParameters(prev => ({ ...prev, nationalCode: { ...prev.nationalCode, color: 'danger' } }));
        }

        if (isValid) {
            const body = {
                nationalCode: passengerProfileParameters.nationalCode.value,
                birthDate: passengerProfileBirthdate ? moment.from(passengerProfileBirthdate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '',
                marriageDate: passengerProfileMarriagedate ? moment.from(passengerProfileMarriagedate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : '',
                state: passengerProfileParameters.state.value,
                city: passengerProfileParameters.city.value,
                address: passengerProfileParameters.address.value
            };

            const parameters = {
                ctrl: 'UserProfile',
                method: 'EditPassengerProfile',
                query: '',
                body
            };

            const result = await post(parameters);
            if (result.status === 200) {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadDashboardProps(`${Math.floor(Math.random() * 100)},editForm`);
            } else {
                alertProps(['danger', result.data.Message]);
            }
            closeModal('passengerProfileModal');
        }
    };

    const sendEmailConfirmCodeHandler = (email) => {
        const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
        setSendEmailConfirmCodeParameters(prev => ({
            ...prev,
            email: { value: email, color: isValid ? 'dark' : 'danger' }
        }));
    };

    const sendEmailConfirmCode = async () => {
        const isValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sendEmailConfirmCodeParameters.email.value);
        if (!isValid) return;

        const body = { Email: sendEmailConfirmCodeParameters.email.value };
        const parameters = {
            ctrl: 'Account',
            method: 'SendEmailConfirmCode',
            query: '',
            body
        };

        const result = await post(parameters);
        if (result.status === 200) {
            setConfirmId(result.data.Id);
            setConfirmEmailState('2');
            setEmailAlert('');
            setTimerStatus(true);
            let helper = 60;
            const interval = setInterval(() => {
                if (helper > 0) {
                    helper--;
                    setTimer(helper);
                } else {
                    clearInterval(interval);
                    setTimerStatus(false);
                }
            }, 1000);
        } else {
            setSendEmailConfirmCodeParameters(prev => ({
                ...prev,
                email: { ...prev.email, color: 'danger' }
            }));
        }
    };

    const verifyEmailConfirmCode = async () => {
        const body = { Id: confirmId, VerifyCode: verifyCode };
        const parameters = {
            ctrl: 'Account',
            method: 'VerifyEmailConfirmCode',
            query: '',
            body
        };

        const result = await post(parameters);
        if (result.status === 200) {
            setUserProfileParameters(prev => ({ ...prev, email: { value: sendEmailConfirmCodeParameters.email.value, color: 'dark' } }));
            setConfirmEmailState('3');
        } else {
            setEmailAlert(result.data.Message);
        }
    };

    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    };
    const fetchCitiesAndStates = async () => {
    
        const result = await getAPI({
            ctrl: 'Common',
            method: 'StateAndCities',
            query: ''
        });
    
        if (result.status === 200) {
            setCitiesAndStates(result.data);
        }
    };
    
    const closeModal = (modal) => {
        document.querySelector(`.${modal}`).classList.add('d-none');
        setConfirmEmailState('1');
        setSendEmailConfirmCodeParameters({ email: { value: '', color: 'dark' } });
        setVerifyCode('');
        setConfirmId('');
        setEmailAlert('');
        setTimerStatus(false);
    };

    const toggleCaldendar = (event, calendar) => {
        if (event.target.tagName === 'INPUT' && calendar === 'birthdateCalendar') setPassengerProfileBirthdate('');
        if (event.target.tagName === 'INPUT' && calendar === 'marriageDateCalendar') setPassengerProfileMarriagedate('');
        document.querySelector(`.${calendar}`).classList.toggle('d-none');
    };

    return (
        <React.Fragment>
            <Box className="p-xl bg-white border-solid border-light rounded-lg" component="form">
                <Typography className="my-lg mt-0" component="p">
                در صورت نیاز به تغییر اطلاعات، از طریق این فرم اقدام نمایید.
                </Typography>

                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item size="col-12">
                            <TextField
                                onChange={(e) => userProfileHandler('firstName', e)}
                                variant="filled"
                                color={userProfileParameters.firstName.color}
                                label='نام *'
                                icon={EditSVG}
                                placeholder='نام به فارسی'
                                value={userProfileParameters.firstName.value}
                            />
                        </Grid.Item>

                        <Grid.Item size="col-12">
                            <TextField
                                onChange={(e) => userProfileHandler('lastName', e)}
                                variant="filled"
                                color={userProfileParameters.lastName.color}
                                label='نام خانوادگی *'
                                icon={EditSVG}
                                placeholder='نام خانوادگی به فارسی'
                                value={userProfileParameters.lastName.value}
                            />
                        </Grid.Item>

                        <Grid.Item size="col-12">
                            <TextField
                                onChange={(e) => userProfileHandler('mobile', e)}
                                variant="filled"
                                color={userProfileParameters.mobile.color}
                                        label='تلفن همراه *'
                                icon={EditSVG}
                                placeholder='09xxxxxxxxxx'
                                value={userProfileParameters.mobile.value}
                                readonly
                            />
                        </Grid.Item>

                        <Grid.Item size="col-12">
                            <Box onClick={() => openModal('emailConfirmModal')}>
                                <TextField
                                    variant="filled"
                                    color={userProfileParameters.email.color}
                                    label='ایمیل'
                                    icon={EditSVG}
                                    value={userProfileParameters.email.value}
                                    readonly
                                />
                            </Box>
                        </Grid.Item>

                        <Grid.Item size="col-12">
                            <Box
                                    onClick={async () => {
                                        await fetchCitiesAndStates();
                                        openModal('passengerProfileModal');
                                    }}
                                className="d-block pointer text-primary text-end my-xl"
                                ms={{ fontSize: 'var(--font-size-sm)' }}>
                                اطلاعات تکمیلی پروفایل
                            </Box>
                        </Grid.Item>

                        <Grid.Item className="d-flex" size="col-12 md-6">
                            <Button onClick={userProfile} className="w-100" color="primary">
                                ذخیره تغییرات
                            </Button>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Box>

            {/* Email Confirm Modal */}
            <Modal className="emailConfirmModal">
                <Modal.Wrapper size="xs" ms={{ '@media(max-width:576px)': { width: '100% !important' } }}>
                    {confirmEmailState === '1' && (
                        <>
                            <Modal.Header className="border-solid-bottom border-light">
                                {userProfileParameters.email.value ? 'تغییر ایمیل' : 'ثبت ایمیل'}
                                <Box />
                            </Modal.Header>
                            <Box className="my-md mt-0" />
                            <Grid>
                                <Grid.Item size="col-12">
                                    <TextField
                                        onChange={(value) => sendEmailConfirmCodeHandler(value)}
                                        color={sendEmailConfirmCodeParameters.email.color}
                                        label='ایمیل جدید را وارد نمایید'
                                        value={sendEmailConfirmCodeParameters.email.value}
                                    />
                                </Grid.Item>
                                <Grid.Item className="d-flex" size="col-12">
                                    <Button onClick={sendEmailConfirmCode}  color="primary">
                                        {userProfileParameters.email.value ? 'تغییر ایمیل' : 'ثبت ایمیل'}
                                    </Button>
                                    <Box className="mx-sm" />
                                    <Button onClick={() => closeModal('emailConfirmModal')}  variant="outlined" color="danger">
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid>
                        </>
                    )}

                    {confirmEmailState === '2' && (
                        <>
                            <Modal.Header className="border-solid-bottom border-light">
                                کد تایید
                                <Box />
                            </Modal.Header>
                            <Box className="my-md mt-0" />
                            <Typography>
                                کد 6 رقمی ارسال شده به ایمیل {sendEmailConfirmCodeParameters.email.value} را وارد نمایید.
                            </Typography>
                            {emailAlert && (
                                <>
                                    <Box className="my-sm" />
                                    <Box className="d-flex" ms={{ gap: 'var(--sizing-xs)' }}>
                                        <Image src={AlertDangerSVG} ms={{ width: '20px', height: '20px' }} />
                                        <Typography component="strong" ms={{ color: 'var(--red-medium)' }}>
                                            {emailAlert}
                                        </Typography>
                                    </Box>
                                </>
                            )}
                            <Box className="my-sm" />
                            <TextField
                                onChange={setVerifyCode}
                                variant="filled"
                                color="dark"
                                placeholder='کد 6 رقمی'
                                value={verifyCode}
                            />
                            <Box className="my-sm" />
                            <Box className="d-flex justify-content-end" ms={{ gap: 'var(--sizing-xs)' }}>
                                {timer === 0 ? (
                                    <>
                                                <Typography component="small">کد ارسال نشده است؟</Typography>
                                        <Typography onClick={sendEmailConfirmCode} className="text-primary pointer" component="small">
                                            ارسال مجدد
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        <Typography component="small">زمان انتظار برای درخواست دوباره کد :</Typography>
                                        <Typography component="small">{timer}</Typography>
                                    </>
                                )}
                            </Box>
                            <Box className="my-xl" />
                            <Box className="d-flex">
                                <Button onClick={verifyEmailConfirmCode} className="w-25" color="primary">
                                    تایید کد
                                </Button>
                                <Box className="mx-sm" />
                                <Button onClick={() => closeModal('emailConfirmModal')} className="w-25" variant="outlined" color="primary">
                                    بستن
                                </Button>
                            </Box>
                        </>
                    )}

                    {confirmEmailState === '3' && (
                        <>
                            <Modal.Header className="border-solid-bottom border-light">
                                {userProfileParameters.email.value ? 'تغییر ایمیل' : 'ثبت ایمیل'}
                                <Box />
                            </Modal.Header>
                            <Box className="my-md mt-0" />
                            <Box className="d-flex align-item-center" ms={{ gap: 'var(--sizing-sm)' }}>
                                <Image src={CheckGreenSVG} ms={{ width: '32px', height: '32px' }} />
                                <Typography className="text-success" component="h4">
                                    {userProfileParameters.email.value ? 'تغییر ایمیل با موفقیت انجام شد.' : 'ثبت ایمیل با موفقیت انجام شد.'}
                                </Typography>
                            </Box>
                            <Box className="my-md" />
                            <Box className="d-block" ms={{ paddingRight: '42px' }}>
                                {userProfileParameters.email.value ? 'ایمیل جدید :' : 'ایمیل شما :'}{' '}
                                <Typography className="text-bold">{sendEmailConfirmCodeParameters.email.value}</Typography>
                            </Box>
                            <Box className="my-xl" />
                            <Box className="d-flex">
                                <Button onClick={() => closeModal('emailConfirmModal')} className="w-25" variant="outlined" color="primary">
                                    بستن
                                </Button>
                            </Box>
                        </>
                    )}
                </Modal.Wrapper>
            </Modal>

            {/* Passenger Profile Modal */}
            <Modal className="passengerProfileModal">
                <Modal.Wrapper size="xs" ms={{ '@media(max-width:576px)': { width: 'calc(100% - 12px) !important' } }}>
                    <Modal.Header className="border-solid-bottom border-light">
                        اطلاعات تکمیلی پروفایل
                        <Box />
                    </Modal.Header>
                    <Box className="my-md mt-0" />
                    <Typography className="px-lg">
                        می توانید اطلاعات تکمیلی پروفایل خود را ویرایش نمایید
                    </Typography>
                    <Box component="form">
                        <Grid>
                            <Grid.Wrapper className="px-sm">
                                <Grid.Item size="col-12 md-4">
                                    <TextField
                                        onChange={(e) => passengerProfileHandler('nationalCode', e)}
                                        color={passengerProfileParameters.nationalCode.color}
                                        label='کد ملی *'
                                        icon={EditSVG}
                                        value={passengerProfileParameters.nationalCode.value}
                                    />
                                </Grid.Item>

                                <Grid.Item className="position-relative" size="col-12 md-4">
                                    <Box onClick={(e) => toggleCaldendar(e, 'birthdateCalendar')}>
                                        <TextField label='تاریخ تولد' icon={CalendarSVG} value={passengerProfileBirthdate} />
                                        <Box className="d-none calendar birthdateCalendar position-absolute" ms={{ width: '320px', top: '80px', zIndex: '1' }}>
                                            <Calendar onChange={setPassengerProfileBirthdate} maxDate={today} />
                                        </Box>
                                    </Box>
                                </Grid.Item>

                                <Grid.Item className="position-relative" size="col-12 md-4">
                                    <Box onClick={(e) => toggleCaldendar(e, 'marriageDateCalendar')}>
                                        <TextField label='تاریخ ازدواج' icon={CalendarSVG} value={passengerProfileMarriagedate} />
                                        <Box className="d-none calendar marriageDateCalendar position-absolute" ms={{ width: '320px', top: '80px', zIndex: '1' }}>
                                            <Calendar onChange={setPassengerProfileMarriagedate} maxDate={today} />
                                        </Box>
                                    </Box>
                                </Grid.Item>

                                <Grid.Item size="col-6">
                                    <Select
                                        onChange={(e) => passengerProfileHandler('state', e)}
                                        color={passengerProfileParameters.state.color}
                                        label='استان'
                                        search
                                        init={passengerProfileParameters.state.value}
                                        readonly>
                                        {states.map((obj) => (
                                            <Select.Item key={obj.id} value={obj.id}>
                                                {obj.title}
                                            </Select.Item>
                                        ))}
                                    </Select>
                                </Grid.Item>

                                <Grid.Item size="col-6">
                                    <Select
                                        onChange={(e) => passengerProfileHandler('city', e)}
                                        color={passengerProfileParameters.city.color}
                                        label='شهر'
                                        search
                                        init={passengerProfileParameters.city.value}
                                        readonly>
                                        {cities.map((obj) => (
                                            obj.stateId === +passengerProfileParameters.state.value && (
                                                <Select.Item key={obj.id} value={obj.id}>
                                                    {obj.title}
                                                </Select.Item>
                                            )
                                        ))}
                                    </Select>
                                </Grid.Item>

                                <Grid.Item size="col-12">
                                    <TextField
                                        onChange={(e) => passengerProfileHandler('address', e)}
                                        color={passengerProfileParameters.address.color}
                                        label='آدرس'
                                        placeholder='آدرس خود را وارد نمایید'
                                        icon={EditSVG}
                                        value={passengerProfileParameters.address.value}
                                    />
                                </Grid.Item>

                                <Grid.Item className="d-flex" size="col-12 md-6">
                                    <Button onClick={passengerProfile} className="w-25" color="primary">
                                    تایید
                                    </Button>
                                    <Box className="mx-sm" />
                                    <Button onClick={() => closeModal('passengerProfileModal')} className="w-25" variant="outlined" color="danger">
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );
};

export default EditForm;